export const getInitials = (name) => {
  const parts = name.trim().split(" ")
  return parts.length >= 2 ? parts[0][0] + parts[1][0] : parts[0].slice(0, 2)
}

export const parseDate = (str) => {
  if (!str) return null
  const [d, m, y] = str.split(".")
  return new Date(`${y}-${m}-${d}`)
}
export const fmtIso = (iso) => {
  if (!iso) return "…"
  const [y, m, d] = iso.split("-")
  return `${d}.${m}.${y}`
}
